<template>
	<div class="m-agree-box">
		<div>
			<span @click="handleClick" class="agree" :class="{ 'no-agree': !isAgree }"></span>
			{{ t("user.pc.wallet.agreementPrefix") }}
			<span @click="goLink(agreementUrl)">{{ t("user.pc.wallet.agreementLink") }}</span>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "~/composables/useI18n";
import { goLink } from "~/utils/common";

const { t, locale } = useI18n();
const isAgree = defineModel({ type: Boolean, default: true });

const agreementUrl = computed(() => {
	const lang = locale.value === "en" ? "en_us" : "zh_tw";
	return `/dist/protocol/website/service-agreement?lang=${lang}`;
});

const handleClick = () => {
	isAgree.value = !isAgree.value;
};
</script>

<style lang="scss" scoped>
.m-agree-box {
	margin-top: 20px;
	display: flex;
	font-family: Source Han Sans CN;
	font-size: 24px;
	color: #666666;
	line-height: 32px;
	align-items: center;

	.agree {
		margin-bottom: -6px;
		display: inline-block;
		width: 28px;
		height: 28px;
		background: url("@/assets/images/icon_agree.png") no-repeat center center/ 28px 28px;
	}

	.no-agree {
		background: url("@/assets/images/icon_no_agree.png") no-repeat center center/ 28px 28px;
	}

	span {
		color: #c8843c;
	}
}
</style>
